import { Action, createReducer, on } from '@ngrx/store';
import { HistoryState } from './history.state';
import {
  ClearStateAction,
  GetOrderHistoryAction,
  GetOrderHistoryErrorAction,
  GetOrderHistorySuccessAction,
  setLoading,
  setSkeletonLoading,
} from './history.actions';

const initialState = new HistoryState();

const reducer = createReducer(
  initialState,

  on(GetOrderHistoryAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = payload.showLoading;
    newState.isSkeletonLoading = true;
    return newState;
  }),
  on(GetOrderHistorySuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.isSkeletonLoading = false;
    newState.failures = null;
    newState.orderHistory = payload.orderHistory;
    return newState;
  }),
  on(GetOrderHistoryErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  }),
  on(setLoading, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = payload.isLoading;
    return newState;
  }),
  on(setSkeletonLoading, (state, payload) => {
    const newState = { ...state };
    newState.isSkeletonLoading = payload.isSkeletonLoading;
    return newState;
  }),
  on(ClearStateAction, (state, payload) => {
    const newState = { ...state };
    switch (payload.actionType) {
      case 'history':
        newState.orderHistory = null;
        break;
      default:
        break;
    }
    newState.isLoading = false;
    newState.failures = null;
    return newState;
  })
);

export function HistoryReducer(state: HistoryState | null, action: Action) {
  return reducer(state, action);
}
